(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-header', class extends baseComponent.default {
    elements = {
      nav: 'main-nav'
    };

    stickyBreakpoint = window.matchMedia('(min-width: 992px)');

    updateStickyOffset = (height) => {
      if(!this.classList.contains('@sticky')) return;
      document.body.style.setProperty('--sticky-header-offset', '0px');
      if(typeof height !== 'number') {
        this.style.removeProperty('padding-bottom');
        this.classList.remove('@sticky');
        height = this.offsetHeight;
        this.classList.add('@sticky');
      }
      this.style.paddingBottom = `${Math.max(0, height - this.offsetHeight)}px`;
      document.body.style.setProperty('--sticky-header-offset', `${this.$nav.offsetHeight}px`);
    };

    connectedCallback() {
      super.connectedCallback();
      this.stickyBreakpoint.addEventListener('change', this.updateStickyOffset);
    }

    disconnectedCallback() {
      this.stickyBreakpoint.removeEventListener('change', this.updateStickyOffset);
    }
    
    render() {
      this.on('stickyMainHeader', (e, { sticky }) => {
        if(sticky) {
          const height = this.offsetHeight;
          this.classList.add('@sticky');
          this.updateStickyOffset(height);
        } else {
          this.style.removeProperty('padding-bottom');
          this.classList.remove('@sticky');
          document.body.style.setProperty('--sticky-header-offset', '0px');
        }
      })
    };
  });
})();
